export default __webpack_public_path__ + "static/media/facebook.25cb4994.svg";